import React from "react";
import { Box, styled, Typography, TypographyProps } from "@mui/material";
import { useSnackbar } from "notistack";
import { useTranslation } from "react-i18next";
import CopyIcon from "@icons/myicons/copy.svg?react";

const CopyTypographyContainer = styled(Box)(({ theme }) => ({
  display: "inline-flex",
  gap: theme.spacing(1),
  alignItems: "center",
  cursor: "pointer",

  "&:hover": {
    "& .MuiTypography-root, & > div": {
      color: theme.palette.primary.main,
    },
  },
}));

type Props = {
  children: string;
  iconColor?: string;
  copyText?: string;
} & TypographyProps;

export const CopyTypography = ({
  children,
  copyText,
  iconColor = "text.secondary",
  ...rest
}: Props) => {
  const { t } = useTranslation();
  const { enqueueSnackbar } = useSnackbar();
  const handleCopy = (event: React.MouseEvent<HTMLDivElement>) => {
    event.stopPropagation();
    navigator.clipboard.writeText(copyText || children);
    enqueueSnackbar(t("copiedToClipboard"), {
      variant: "success",
      autoHideDuration: 2000,
    });
  };

  return (
    <CopyTypographyContainer onClick={handleCopy}>
      <Box color={iconColor} display="flex" alignItems="center">
        <CopyIcon width={18} height={18} />
      </Box>
      <Typography variant="body3" color="textSecondary" {...rest}>
        {children}
      </Typography>
    </CopyTypographyContainer>
  );
};
